/**
 * 将图片/素材 URL 规范化为当前站点可访问地址。
 * 兼容 DB/API 中存的完整 URL（含 127.0.0.1:8081、旧域名等），统一提取 /uploads/ 路径。
 */
import { getAuthToken } from '@/utils/auth'

export function normalizeImgUrl(v) {
  if (!v) return ''
  const str = String(v).trim()
  const uploadMatch = str.match(/\/uploads\/[^\s?#,]*/i)
  if (uploadMatch) {
    return `${window.location.origin}${uploadMatch[0]}`
  }
  if (str.startsWith('http')) return str
  if (str.startsWith('//')) return window.location.protocol + str
  if (str.startsWith('/')) return window.location.origin + str
  return str
}

/** 从 JSON 数组、逗号分隔或历史脏数据中提取 /uploads/ 相对路径 */
export function extractUploadPaths(v) {
  if (v == null || v === '') return []
  if (Array.isArray(v)) {
    return v.flatMap((item) => extractUploadPaths(item))
  }
  const str = String(v).trim()
  if (!str) return []
  if (str.startsWith('[')) {
    try {
      const parsed = JSON.parse(str)
      if (Array.isArray(parsed)) {
        return parsed.flatMap((item) => extractUploadPaths(item))
      }
    } catch {
      // ignore invalid json
    }
  }
  const matches = str.match(/\/uploads\/[^\s"',[\]?#]+/gi)
  if (matches && matches.length) {
    return [...new Set(matches)]
  }
  if (str.includes(',')) {
    return str
      .split(',')
      .map((part) => extractUploadPaths(part)[0] || part.trim())
      .filter(Boolean)
  }
  if (str.startsWith('http')) {
    try {
      const u = new URL(str)
      return u.pathname.startsWith('/uploads/') ? [u.pathname] : []
    } catch {
      return []
    }
  }
  return str.startsWith('/uploads/') ? [str] : []
}

/** 素材库列表缩略图（img 标签无法带 Header，需 token 参数或后端 @IgnoreJwtAuth） */
export function materialThumbUrl(id, width = 320) {
  if (!id) return ''
  const qs = new URLSearchParams({ id: String(id), w: String(width) })
  const token = getAuthToken()
  if (token) qs.set('token', token)
  return `${window.location.origin}/api/image-libraries/thumbnail?${qs}`
}

/** 解析素材库 el-upload 上传响应（兼容 R 包装与直接 VO） */
export function parseImageLibraryUploadResponse(resp) {
  if (!resp || typeof resp !== 'object') {
    return { ok: false, msg: '上传失败' }
  }
  const body = resp.code !== undefined || resp.success !== undefined || resp.msg !== undefined
    ? resp
    : (resp.data && typeof resp.data === 'object' ? resp.data : resp)

  if (body.code === 200 || body.code === 0 || body.success === true) {
    return { ok: true, msg: body.msg || body.message || '上传成功' }
  }

  const payload = body.data && typeof body.data === 'object' ? body.data : body
  if (payload?.savePath || payload?.id) {
    return { ok: true, msg: body.msg || body.message || '上传成功' }
  }

  return { ok: false, msg: body.msg || body.message || '上传失败' }
}
